/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_2Inputs */



/**
* | output |
* | --- |
* | "Top center" |
*
* @param {Live_Caption_Youtube_Region_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_2 = /** @type {((inputs?: Live_Caption_Youtube_Region_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre supérieur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верхний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("顶部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央上部")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro superior")
	return /** @type {LocalizedString} */ ("Top center")
});